import { Map } from 'immutable'
import { withTranslation } from 'react-i18next'

import { TYPE_OF_REVIEWERS } from 'app/constants/reviews'
import ReviewsSurveyForm from './ReviewsSurveyForm'

export default withTranslation(['admin', 'common'])(ReviewsSurveyForm)

export const validateForm = (values: Map<string, any>) => {
  const errors = {} as {
    _error: string
    superiorMin: string
    peerMin: string
    employeeMin: string
  }
  const minS = parseInt(values.get(`${TYPE_OF_REVIEWERS.SUPERIOR}Min`))
  const minP = parseInt(values.get(`${TYPE_OF_REVIEWERS.PEER}Min`))
  const minE = parseInt(values.get(`${TYPE_OF_REVIEWERS.EMPLOYEE}Min`))
  const sumMin = minS + minP + minE
  if (sumMin === 0 || isNaN(sumMin)) {
    errors._error = 'At least 1 reviewer required for survey'
    errors.superiorMin = 'At least 1 reviewer required for survey'
    errors.peerMin = 'At least 1 reviewer required for survey'
    errors.employeeMin = 'At least 1 reviewer required for survey'
  }
  return errors
}
